import { sdk } from "@gc/ipecs-web-sdk";
import { useQueryClient } from "@tanstack/react-query";
import { logout } from "../api/auth";
import { storageKeys } from "../constants";
import { useAuth } from "../contexts/AuthContext";

// Signs out of iPECS and the API, then clears everything cached for this user
export function useLogout() {
  const queryClient = useQueryClient();
  const { setApiUser, setIpecsUser, setIpecsAuthenticated, setLoggingOut } =
    useAuth();

  return async () => {
    setLoggingOut(true);
    try {
      await sdk.auth.logout();
    } catch (e) {
      if (e.message !== "E_UNKNOWN_TOKEN") {
        setLoggingOut(false);
        throw e;
      }
    }
    await logout();
    queryClient.clear();
    localStorage.removeItem(storageKeys.IPECS_LOGIN);
    localStorage.removeItem(storageKeys.ACD_AGENT_ID);
    localStorage.removeItem(storageKeys.ACD_ENABLED);
    localStorage.removeItem(storageKeys.IPECS_AUTH);
    setIpecsAuthenticated(false);
    setIpecsUser();
    setApiUser();
    setLoggingOut(false);
  };
}
